import React, { useState } from 'react'
import styles from './ReportsPage.module.scss'
import { Layout } from "components";
import {
	getReportGuards,
	getReportTopBases,
	getReportChpps,
	getReportPrivatePoints,
	getReportTopBaseOperators,
	getReportChppOperators,
	getReportPrivatePointOperators,
	getReportTopBaseDrivers,
	getReportChppDrivers,
	getReportPrivatePointDrivers,
	getReportTopBaseBranches,
	getReportChppBranches,
	getReportPrivatePointBranches,
	getReportAllDrivers,
	getReportAllBranches,
	getReportLoadingsStatistics,
	getReportTopDriversByLoads,
} from "service/ReportsService";
import Notification from "utils/Notifications";
import GuardsPanel from './Blocks/GuardsPanel'
import TopBasesPanel from './Blocks/TopBasesPanel'
import ChppsPanel from './Blocks/ChppsPanel'
import PrivatePointsPanel from './Blocks/PrivatePointsPanel'
import TopBasesMapView from './Blocks/TopBasesMapView'
import ChppsMapView from './Blocks/ChppsMapView'
import PrivatePointsMapView from './Blocks/PrivatePointsMapView'
import AllDriversPanel from './Blocks/AllDriversPanel'
import LoadingsPanel from './Blocks/LoadingsPanel'

const ReportsPage = () => {

	const [open, setOpen] = useState('loadings')

	const toggle = (id) => setOpen((prev) => (prev === id ? null : id))
	const [notify, setNotify] = useState({
		isOpen: false,
		message: "",
		type: "",
	});
	// data
	const [guards, setGuards] = useState([])
	const [topBases, setTopBases] = useState([])
	const [chpps, setChpps] = useState([])
	const [privatePoints, setPrivatePoints] = useState([])
	const [allPrivatePoints, setAllPrivatePoints] = useState([])
	const [drivers, setDrivers] = useState([])
	const [guardsPagination, setGuardsPagination] = useState({})
	const [topBasesPagination, setTopBasesPagination] = useState({})
	const [chppsPagination, setChppsPagination] = useState({})
	const [privatePointsPagination, setPrivatePointsPagination] = useState({})
	const [driversPagination, setDriversPagination] = useState({})
	const [guardsFilter, setGuardsFilter] = useState('')
	const [topBasesFilter, setTopBasesFilter] = useState('')
	const [chppsFilter, setChppsFilter] = useState('')
	const [privatePointsFilter, setPrivatePointsFilter] = useState('')
	const [driversFilter, setDriversFilter] = useState('')
	const [operatorsByTopBase, setOperatorsByTopBase] = useState({})
	const [operatorsPaginationByTopBase, setOperatorsPaginationByTopBase] = useState({})
	const [driversByTopBase, setDriversByTopBase] = useState({})
	const [driversPaginationByTopBase, setDriversPaginationByTopBase] = useState({})
	const [branchesByTopBase, setBranchesByTopBase] = useState({})
	const [branchesPaginationByTopBase, setBranchesPaginationByTopBase] = useState({})
	const [operatorsByChpp, setOperatorsByChpp] = useState({})
	const [operatorsPaginationByChpp, setOperatorsPaginationByChpp] = useState({})
	const [driversByChpp, setDriversByChpp] = useState({})
	const [driversPaginationByChpp, setDriversPaginationByChpp] = useState({})
	const [branchesByChpp, setBranchesByChpp] = useState({})
	const [branchesPaginationByChpp, setBranchesPaginationByChpp] = useState({})
	const [operatorsByPrivatePoint, setOperatorsByPrivatePoint] = useState({})
	const [operatorsPaginationByPrivatePoint, setOperatorsPaginationByPrivatePoint] = useState({})
	const [driversByPrivatePoint, setDriversByPrivatePoint] = useState({})
	const [driversPaginationByPrivatePoint, setDriversPaginationByPrivatePoint] = useState({})
	const [branchesByPrivatePoint, setBranchesByPrivatePoint] = useState({})
	const [branchesPaginationByPrivatePoint, setBranchesPaginationByPrivatePoint] = useState({})
	const [allBranches, setAllBranches] = useState([])
	const [topDriversByLoads, setTopDriversByLoads] = useState([])
	const [expandedOperatorsTopBase, setExpandedOperatorsTopBase] = useState(null)
	const [expandedDriversTopBase, setExpandedDriversTopBase] = useState(null)
	const [expandedBranchesTopBase, setExpandedBranchesTopBase] = useState(null)
	const [expandedOperatorsChpp, setExpandedOperatorsChpp] = useState(null)
	const [expandedDriversChpp, setExpandedDriversChpp] = useState(null)
	const [expandedBranchesChpp, setExpandedBranchesChpp] = useState(null)
	const [expandedOperatorsPrivatePoint, setExpandedOperatorsPrivatePoint] = useState(null)
	const [expandedDriversPrivatePoint, setExpandedDriversPrivatePoint] = useState(null)
	const [expandedBranchesPrivatePoint, setExpandedBranchesPrivatePoint] = useState(null)
	const [operatorsFilterByTopBase, setOperatorsFilterByTopBase] = useState({})
	const [driversFilterByTopBase, setDriversFilterByTopBase] = useState({})
	const [branchesFilterByTopBase, setBranchesFilterByTopBase] = useState({})
	const [operatorsFilterByChpp, setOperatorsFilterByChpp] = useState({})
	const [driversFilterByChpp, setDriversFilterByChpp] = useState({})
	const [branchesFilterByChpp, setBranchesFilterByChpp] = useState({})
	const [operatorsFilterByPrivatePoint, setOperatorsFilterByPrivatePoint] = useState({})
	const [driversFilterByPrivatePoint, setDriversFilterByPrivatePoint] = useState({})
	const [branchesFilterByPrivatePoint, setBranchesFilterByPrivatePoint] = useState({})
	const [expandedDriverByTopBase, setExpandedDriverByTopBase] = useState({})
	const [expandedDriverByChpp, setExpandedDriverByChpp] = useState({})
	const [expandedDriverByPrivatePoint, setExpandedDriverByPrivatePoint] = useState({})

	// UI state for expansion
	const [expandedTopBase, setExpandedTopBase] = useState(null)
	const [expandedChpp, setExpandedChpp] = useState(null)
	const [expandedPrivatePoint, setExpandedPrivatePoint] = useState(null)
	
	// Loadings statistics state
	const [loadingsData, setLoadingsData] = useState({
		loads: [],
		driversStatus: { blocked: 0, free: 0, in_loading: 0, in_route: 0 },
		loadsSummary: { in_loading: 0, in_route: 0, completed: 0, pending: 0 },
		baseStats: [],
		delivery_time: { longest: null, shortest: null, median: null },
		loading_time: { longest: null, shortest: null, median: null }
	})

	const toggleDriver = (topBaseId, driverId) => {
		setExpandedDriverByTopBase(prev => ({ ...prev, [topBaseId]: prev[topBaseId] === driverId ? null : driverId }))
	}

	const toggleDriverChpp = (chppId, driverId) => {
		setExpandedDriverByChpp(prev => ({ ...prev, [chppId]: prev[chppId] === driverId ? null : driverId }))
	}

	const toggleDriverPrivatePoint = (privatePointId, driverId) => {
		setExpandedDriverByPrivatePoint(prev => ({ ...prev, [privatePointId]: prev[privatePointId] === driverId ? null : driverId }))
	}

	// Debounced search - reload data from server when filter changes
	React.useEffect(() => {
		if (open !== 'kpp') return
		const timer = setTimeout(() => {
			loadGuardsPage(1, guardsFilter)
		}, 300)
		return () => clearTimeout(timer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [guardsFilter])

	React.useEffect(() => {
		if (open !== 'top') return
		const timer = setTimeout(() => {
			loadTopBasesPage(1, topBasesFilter)
		}, 300)
		return () => clearTimeout(timer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [topBasesFilter])

	React.useEffect(() => {
		if (open !== 'chpp') return
		const timer = setTimeout(() => {
			loadChppsPage(1, chppsFilter)
		}, 300)
		return () => clearTimeout(timer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [chppsFilter])

	React.useEffect(() => {
		if (open !== 'private') return
		const timer = setTimeout(() => {
			loadPrivatePointsPage(1, privatePointsFilter)
		}, 300)
		return () => clearTimeout(timer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [privatePointsFilter])

	// driversFilter debounce is handled inside AllDriversPanel to preserve status/active filters

	// Debounced search for drivers by TopBase
	React.useEffect(() => {
		Object.keys(driversFilterByTopBase).forEach(topBaseId => {
			const searchQuery = driversFilterByTopBase[topBaseId]
			if (searchQuery !== undefined && expandedDriversTopBase === parseInt(topBaseId)) {
				const timer = setTimeout(() => {
					loadDriversByTopBasePage(topBaseId, 1, searchQuery)
				}, 300)
				return () => clearTimeout(timer)
			}
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [driversFilterByTopBase, expandedDriversTopBase])

	// Debounced search for drivers by CHPP
	React.useEffect(() => {
		Object.keys(driversFilterByChpp).forEach(chppId => {
			const searchQuery = driversFilterByChpp[chppId]
			if (searchQuery !== undefined && expandedDriversChpp === parseInt(chppId)) {
				const timer = setTimeout(() => {
					loadDriversByChppPage(chppId, 1, searchQuery)
				}, 300)
				return () => clearTimeout(timer)
			}
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [driversFilterByChpp, expandedDriversChpp])

	// Debounced search for drivers by PrivatePoint
	React.useEffect(() => {
		Object.keys(driversFilterByPrivatePoint).forEach(privatePointId => {
			const searchQuery = driversFilterByPrivatePoint[privatePointId]
			if (searchQuery !== undefined && expandedDriversPrivatePoint === parseInt(privatePointId)) {
				const timer = setTimeout(() => {
					loadDriversByPrivatePointPage(privatePointId, 1, searchQuery)
				}, 300)
				return () => clearTimeout(timer)
			}
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [driversFilterByPrivatePoint, expandedDriversPrivatePoint])

	const processPaged = (res) => {
		const data = res?.data || res
		if (data && typeof data === 'object' && Array.isArray(data.results)) {
			return { items: data.results, pagination: { count: data.count, next: data.next, previous: data.previous } }
		}
		return { items: Array.isArray(data) ? data : [], pagination: {} }
	}

	// notification helpers
	const notifyError = (err, defaultMsg = 'Ошибка') => {
		let message = defaultMsg
		try {
			if (err && err.response && err.response.data) {
				const data = err.response.data
				if (typeof data === 'string') message = data
				else if (data.detail) message = data.detail
				else if (data.message) message = data.message
				else if (data.non_field_errors) message = (Array.isArray(data.non_field_errors) ? data.non_field_errors.join('; ') : String(data.non_field_errors))
				else if (typeof data === 'object') {
					for (const key of Object.keys(data)) {
						const val = data[key]
						if (!val) continue
						if (Array.isArray(val) && val.length) { message = String(val[0]); break }
						if (typeof val === 'string') { message = val; break }
					}
					if (message === defaultMsg) message = JSON.stringify(data)
				} else message = JSON.stringify(data)
			} else if (err && err.message) {
				message = err.message
			}
		} catch (e) {
			message = defaultMsg
		}
		setNotify({ isOpen: true, message: String(message), type: 'error', sound: 'error' })
	}

	// loaders with page support
	const loadDriversPage = async (page = 1, search = '', statusFilter = '', activeFilter = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			if (statusFilter) params.status_filter = statusFilter
			if (activeFilter) params.is_active = activeFilter === 'active' ? 'true' : activeFilter === 'inactive' ? 'false' : ''
			const res = await getReportAllDrivers(params)
			const { items, pagination } = processPaged(res)
			setDrivers(items)
			setDriversPagination({ ...pagination, page })
		} catch (err) { console.error('Failed to load drivers page', err) }
	}

	const loadGuardsPage = async (page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportGuards(params)
			const { items, pagination } = processPaged(res)
			setGuards(items)
			setGuardsPagination({ ...pagination, page })
		} catch (err) { console.error('Failed to load guards page', err) }
	}

	const loadTopBasesPage = async (page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportTopBases(params)
			const { items, pagination } = processPaged(res)
			setTopBases(items)
			setTopBasesPagination({ ...pagination, page })
		} catch (err) { console.error('Failed to load top bases page', err) }
	}

	const loadChppsPage = async (page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportChpps(params)
			const { items, pagination } = processPaged(res)
			setChpps(items)
			setChppsPagination({ ...pagination, page })
		} catch (err) { console.error('Failed to load chpps page', err) }
	}

	const loadOperatorsByTopBasePage = async (topBaseId, page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportTopBaseOperators(topBaseId, params)
			const { items, pagination } = processPaged(res)
			setOperatorsByTopBase((prev) => ({ ...prev, [topBaseId]: items }))
			setOperatorsPaginationByTopBase((prev) => ({ ...prev, [topBaseId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load operators for top base', topBaseId, err)
			notifyError(err, 'Не удалось загрузить операторов для ТОП-базы')
		}
	}

	const loadDriversByTopBasePage = async (topBaseId, page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportTopBaseDrivers(topBaseId, params)
			const { items, pagination } = processPaged(res)
			setDriversByTopBase((prev) => ({ ...prev, [topBaseId]: items }))
			setDriversPaginationByTopBase((prev) => ({ ...prev, [topBaseId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load drivers for top base', topBaseId, err)
			notifyError(err, 'Не удалось загрузить водителей для ТОП-базы')
		}
	}

	const loadBranchesByTopBasePage = async (topBaseId, page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportTopBaseBranches(topBaseId, params)
			const { items, pagination } = processPaged(res)
			setBranchesByTopBase((prev) => ({ ...prev, [topBaseId]: items }))
			setBranchesPaginationByTopBase((prev) => ({ ...prev, [topBaseId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load branches for top base', topBaseId, err)
			notifyError(err, 'Не удалось загрузить филиалы для ТОП-базы')
		}
	}

	const loadOperatorsByChppPage = async (chppId, page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportChppOperators(chppId, params)
			const { items, pagination } = processPaged(res)
			setOperatorsByChpp((prev) => ({ ...prev, [chppId]: items }))
			setOperatorsPaginationByChpp((prev) => ({ ...prev, [chppId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load operators for chpp', chppId, err)
			notifyError(err, 'Не удалось загрузить операторов для ТЭЦ')
		}
	}

	const loadDriversByChppPage = async (chppId, page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportChppDrivers(chppId, params)
			const { items, pagination } = processPaged(res)
			setDriversByChpp((prev) => ({ ...prev, [chppId]: items }))
			setDriversPaginationByChpp((prev) => ({ ...prev, [chppId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load drivers for chpp', chppId, err)
			notifyError(err, 'Не удалось загрузить водителей для ТЭЦ')
		}
	}

	const loadBranchesByChppPage = async (chppId, page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportChppBranches(chppId, params)
			const { items, pagination } = processPaged(res)
			setBranchesByChpp((prev) => ({ ...prev, [chppId]: items }))
			setBranchesPaginationByChpp((prev) => ({ ...prev, [chppId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load branches for chpp', chppId, err)
			notifyError(err, 'Не удалось загрузить филиалы для ТЭЦ')
		}
	}

	const loadPrivatePointsPage = async (page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportPrivatePoints(params)
			const { items, pagination } = processPaged(res)
			setPrivatePoints(items)
			setPrivatePointsPagination({ ...pagination, page })
		} catch (err) { console.error('Failed to load private points page', err) }
	}

	const loadOperatorsByPrivatePointPage = async (privatePointId, page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportPrivatePointOperators(privatePointId, params)
			const { items, pagination } = processPaged(res)
			setOperatorsByPrivatePoint((prev) => ({ ...prev, [privatePointId]: items }))
			setOperatorsPaginationByPrivatePoint((prev) => ({ ...prev, [privatePointId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load operators for private point', privatePointId, err)
			notifyError(err, 'Не удалось загрузить операторов для соц.объекта или МСУ')
		}
	}

	const loadDriversByPrivatePointPage = async (privatePointId, page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportPrivatePointDrivers(privatePointId, params)
			const { items, pagination } = processPaged(res)
			setDriversByPrivatePoint((prev) => ({ ...prev, [privatePointId]: items }))
			setDriversPaginationByPrivatePoint((prev) => ({ ...prev, [privatePointId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load drivers for private point', privatePointId, err)
			notifyError(err, 'Не удалось загрузить водителей для соц.объекта или МСУ')
		}
	}

	const loadBranchesByPrivatePointPage = async (privatePointId, page = 1, search = '') => {
		try {
			const params = { page }
			if (search) params.search = search
			const res = await getReportPrivatePointBranches(privatePointId, params)
			const { items, pagination } = processPaged(res)
			setBranchesByPrivatePoint((prev) => ({ ...prev, [privatePointId]: items }))
			setBranchesPaginationByPrivatePoint((prev) => ({ ...prev, [privatePointId]: { ...pagination, page } }))
		} catch (err) {
			console.error('Failed to load branches for private point', privatePointId, err)
			notifyError(err, 'Не удалось загрузить филиалы для соц.объекта или МСУ')
		}
	}

	const loadAllPrivatePoints = async () => {
		try {
			const res = await getReportPrivatePoints()
			const { items } = processPaged(res)
			setAllPrivatePoints(items)
		} catch (err) {
			console.error('Failed to load all private points', err)
		}
	}

	const loadAllBranches = async () => {
		try {
			let allItems = []
			let page = 1
			let hasMore = true
			
			while (hasMore) {
				const res = await getReportAllBranches({ page, page_size: 100 })
				const { items, pagination } = processPaged(res)
				allItems = [...allItems, ...items]
				
				if (pagination.next) {
					page++
				} else {
					hasMore = false
				}
			}
			
			setAllBranches(allItems)
		} catch (err) {
			console.error('Failed to load all branches', err)
			notifyError(err, 'Не удалось загрузить все филиалы')
		}
	}

	// watch panel open changes
	React.useEffect(() => {
		if (open === 'kpp') {
			setGuardsFilter('')
			loadGuardsPage(1, '')
		}
		if (open === 'top') {
			setTopBasesFilter('')
			loadTopBasesPage(1, '')
			loadAllBranches()
		}
		if (open === 'chpp') {
			setChppsFilter('')
			loadChppsPage(1, '')
			loadAllBranches()
		}
		if (open === 'private') {
			setPrivatePointsFilter('')
			loadPrivatePointsPage(1, '')
			loadAllPrivatePoints()
			loadAllBranches()
		}
		if (open === 'drivers') {
			setDriversFilter('')
			loadDriversPage(1, '')
			loadTopDriversByLoads()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open])

	const loadTopDriversByLoads = async () => {
		try {
			const res = await getReportTopDriversByLoads()
			const data = res?.data || res
			console.log('Top drivers by loads:', data)
			setTopDriversByLoads(Array.isArray(data) ? data : [])
		} catch (err) {
			console.error('Failed to load top drivers by loads', err)
		}
	}

	// Load loadings statistics
	const loadLoadingsStatistics = async () => {
		try {
			const res = await getReportLoadingsStatistics()
			const data = res?.data || res
			setLoadingsData({
				loads: data.loads || [],
				driversStatus: data.drivers_status || { blocked: 0, free: 0, in_loading: 0, in_route: 0 },
				loadsSummary: data.loads_summary || { in_loading: 0, in_route: 0, completed: 0, pending: 0 },
				baseStats: data.base_stats || [],
				delivery_time: data.delivery_time || { longest: null, shortest: null, median: null },
				loading_time: data.loading_time || { longest: null, shortest: null, median: null },
				processedRequests: data.processed_requests || { total: 0, driver_registrations: 0, base_requests: 0 },
				baseTypeStats: data.base_type_stats || { top_base: 0, chpp: 0, private_point: 0 },
			})
		} catch (err) {
			console.error('Failed to load loadings statistics', err)
			notifyError(err, 'Ошибка загрузки статистики погрузок')
		}
	}

	React.useEffect(() => {
		if (open === 'loadings') {
			loadLoadingsStatistics()
			
			// Автоматическое обновление каждую минуту (60000 мс)
			const intervalId = setInterval(() => {
				loadLoadingsStatistics()
			}, 40000)
			
			// Очистка интервала при размонтировании или изменении open
			return () => clearInterval(intervalId)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open])


	return (
		<Layout>
			<div className={styles.wrapper}>
				<div className={styles.adminPanel}>
					<div className={styles.item}>
						<div className={styles.title}>Охрана КПП</div>
						<button className={styles.button} onClick={() => toggle('kpp')}>
							{open === 'kpp' ? 'Скрыть' : 'Показать'}
						</button>
					</div>

					<div className={styles.item}>
						<div className={styles.title}>ТОП-Базы</div>
						<button className={styles.button} onClick={() => toggle('top')}>
							{open === 'top' ? 'Скрыть' : 'Показать'}
						</button>
					</div>

					<div className={styles.item}>
						<div className={styles.title}>ТЭЦ</div>
						<button className={styles.button} onClick={() => toggle('chpp')}>
							{open === 'chpp' ? 'Скрыть' : 'Показать'}
						</button>
					</div>

					<div className={styles.item}>
						<div className={styles.title}>Соц. Объекты и МСУ</div>
						<button className={styles.button} onClick={() => toggle('private')}>
							{open === 'private' ? 'Скрыть' : 'Показать'}
						</button>
					</div>

					<div className={styles.item}>
						<div className={styles.title}>Водители</div>
						<button className={styles.button} onClick={() => toggle('drivers')}>
							{open === 'drivers' ? 'Скрыть' : 'Показать'}
						</button>
					</div>

					<div className={styles.item}>
						<div className={styles.title}>Погрузки</div>
						<button className={styles.button} onClick={() => toggle('loadings')}>
							{open === 'loadings' ? 'Скрыть' : 'Показать'}
						</button>
					</div>
				</div>

				{/* panels container - always rendered below the buttons */}
				<div className={styles.panelsContainer}>
					{open === 'kpp' && (
						<GuardsPanel
						  guardsFilter={guardsFilter}
						  setGuardsFilter={setGuardsFilter}
						  filteredGuards={guards}
						  guardsPagination={guardsPagination}
						  loadGuardsPage={loadGuardsPage}
						/>
					)}

					{open === 'top' && (
						<>
							<TopBasesPanel
							  topBasesFilter={topBasesFilter}
							  setTopBasesFilter={setTopBasesFilter}
							  filteredTopBases={topBases}
							  topBasesPagination={topBasesPagination}
							  loadTopBasesPage={loadTopBasesPage}
							  expandedTopBase={expandedTopBase}
							  setExpandedTopBase={setExpandedTopBase}
							  expandedOperatorsTopBase={expandedOperatorsTopBase}
							  setExpandedOperatorsTopBase={setExpandedOperatorsTopBase}
							  expandedDriversTopBase={expandedDriversTopBase}
							  setExpandedDriversTopBase={setExpandedDriversTopBase}
							  expandedBranchesTopBase={expandedBranchesTopBase}
							  setExpandedBranchesTopBase={setExpandedBranchesTopBase}
							  loadOperatorsByTopBasePage={loadOperatorsByTopBasePage}
							  loadDriversByTopBasePage={loadDriversByTopBasePage}
							  loadBranchesByTopBasePage={loadBranchesByTopBasePage}
							  operatorsByTopBase={operatorsByTopBase}
							  driversByTopBase={driversByTopBase}
							  branchesByTopBase={branchesByTopBase}
							  operatorsPaginationByTopBase={operatorsPaginationByTopBase}
							  driversPaginationByTopBase={driversPaginationByTopBase}
							  branchesPaginationByTopBase={branchesPaginationByTopBase}
							  operatorsFilterByTopBase={operatorsFilterByTopBase}
							  driversFilterByTopBase={driversFilterByTopBase}
							  branchesFilterByTopBase={branchesFilterByTopBase}
							  setOperatorsFilterByTopBase={setOperatorsFilterByTopBase}
							  setDriversFilterByTopBase={setDriversFilterByTopBase}
							  setBranchesFilterByTopBase={setBranchesFilterByTopBase}

							  expandedDriverByTopBase={expandedDriverByTopBase}
							  toggleDriver={toggleDriver}
							  topBases={topBases}
							/>
							<TopBasesMapView branches={allBranches} topBases={topBases} />
						</>
					)}

				{open === 'chpp' && (
					<>
						<ChppsPanel
						  chppsFilter={chppsFilter}
						  setChppsFilter={setChppsFilter}
						  filteredChpps={chpps}
						  chppsPagination={chppsPagination}
						  loadChppsPage={loadChppsPage}
						  expandedChpp={expandedChpp}
						  setExpandedChpp={setExpandedChpp}
						  expandedOperatorsChpp={expandedOperatorsChpp}
						  setExpandedOperatorsChpp={setExpandedOperatorsChpp}
						  expandedDriversChpp={expandedDriversChpp}
						  setExpandedDriversChpp={setExpandedDriversChpp}
						  expandedBranchesChpp={expandedBranchesChpp}
						  setExpandedBranchesChpp={setExpandedBranchesChpp}
						  loadOperatorsByChppPage={loadOperatorsByChppPage}
						  loadDriversByChppPage={loadDriversByChppPage}
						  loadBranchesByChppPage={loadBranchesByChppPage}
						  operatorsByChpp={operatorsByChpp}
						  driversByChpp={driversByChpp}
						  branchesByChpp={branchesByChpp}
						  operatorsPaginationByChpp={operatorsPaginationByChpp}
						  driversPaginationByChpp={driversPaginationByChpp}
						  branchesPaginationByChpp={branchesPaginationByChpp}
						  operatorsFilterByChpp={operatorsFilterByChpp}
						  driversFilterByChpp={driversFilterByChpp}
						  branchesFilterByChpp={branchesFilterByChpp}
						  setOperatorsFilterByChpp={setOperatorsFilterByChpp}
						  setDriversFilterByChpp={setDriversFilterByChpp}
						  setBranchesFilterByChpp={setBranchesFilterByChpp}

						  expandedDriverByChpp={expandedDriverByChpp}
						  toggleDriver={toggleDriverChpp}
						  chpps={chpps}
					/>
					<ChppsMapView chpps={chpps} branches={allBranches} />
				</>
				)}

				{open === 'private' && (
					<>
						<PrivatePointsPanel
						  privatePointsFilter={privatePointsFilter}
						  setPrivatePointsFilter={setPrivatePointsFilter}
						  filteredPrivatePoints={privatePoints}
						  privatePointsPagination={privatePointsPagination}
						  loadPrivatePointsPage={loadPrivatePointsPage}
						  expandedPrivatePoint={expandedPrivatePoint}
						  setExpandedPrivatePoint={setExpandedPrivatePoint}
						  expandedOperatorsPrivatePoint={expandedOperatorsPrivatePoint}
						  setExpandedOperatorsPrivatePoint={setExpandedOperatorsPrivatePoint}
						  expandedDriversPrivatePoint={expandedDriversPrivatePoint}
						  setExpandedDriversPrivatePoint={setExpandedDriversPrivatePoint}
						  expandedBranchesPrivatePoint={expandedBranchesPrivatePoint}
						  setExpandedBranchesPrivatePoint={setExpandedBranchesPrivatePoint}
						  loadOperatorsByPrivatePointPage={loadOperatorsByPrivatePointPage}
						  loadDriversByPrivatePointPage={loadDriversByPrivatePointPage}
						  loadBranchesByPrivatePointPage={loadBranchesByPrivatePointPage}
						  operatorsByPrivatePoint={operatorsByPrivatePoint}
						  driversByPrivatePoint={driversByPrivatePoint}
						  branchesByPrivatePoint={branchesByPrivatePoint}
						  operatorsPaginationByPrivatePoint={operatorsPaginationByPrivatePoint}
						  driversPaginationByPrivatePoint={driversPaginationByPrivatePoint}
						  branchesPaginationByPrivatePoint={branchesPaginationByPrivatePoint}
						  operatorsFilterByPrivatePoint={operatorsFilterByPrivatePoint}
						  driversFilterByPrivatePoint={driversFilterByPrivatePoint}
						  branchesFilterByPrivatePoint={branchesFilterByPrivatePoint}
						  setOperatorsFilterByPrivatePoint={setOperatorsFilterByPrivatePoint}
						  setDriversFilterByPrivatePoint={setDriversFilterByPrivatePoint}
						  setBranchesFilterByPrivatePoint={setBranchesFilterByPrivatePoint}

						  expandedDriverByPrivatePoint={expandedDriverByPrivatePoint}
						  toggleDriver={toggleDriverPrivatePoint}
						  privatePoints={privatePoints}
						/>
						<PrivatePointsMapView branches={allBranches} privatePoints={allPrivatePoints} />
					</>
				)} 



				
						
				{open === 'drivers' && (
						<AllDriversPanel
							drivers={drivers}
							driversPagination={driversPagination}
							driversFilter={driversFilter}
							setDriversFilter={setDriversFilter}
							loadDriversPage={loadDriversPage}
							topBases={topBases}
							chpps={chpps}
							privatePoints={privatePoints}
							topDriversByLoads={topDriversByLoads}
						/>
					)}

				{open === 'loadings' && (
					<LoadingsPanel
						loadings={loadingsData}
						driversStatus={loadingsData.driversStatus}
					/>
				)}
				</div>
				
				<Notification notify={notify} setNotify={setNotify} />
			</div>

		</Layout>

	)
}

export default ReportsPage
